"use client";

import { useState } from "react";

interface ProtectedEmailProps {
  encodedEmail: string;
  className?: string;
}

export default function ProtectedEmail({
  encodedEmail,
  className,
}: ProtectedEmailProps) {
  const [href, setHref] = useState<string>("javascript:void(0);");

  const handleInteraction = () => {
    if (href === "javascript:void(0);") {
      const decoded = atob(encodedEmail);
      setHref(`mailto:${decoded}`);
    }
  };

  return (
    <a
      href={href}
      onPointerEnter={handleInteraction}
      onClick={handleInteraction}
      className={className}
    >
      info@mpay.al
    </a>
  );
}